import clsx from 'clsx';

import { Icon } from '@atom/mui';
import { type IconComponent } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { WorkOrderTab } from '@atom/types/work';

import classes from './workOrderDetailHeader.module.css';

export interface Props {
  view: {
    value: WorkOrderTab;
    label: string;
    icon: IconComponent;
    dataCy: string;
  };
  activeView: WorkOrderTab;
  setActiveView: (view: WorkOrderTab) => void;
  // displays error bullet on tab when true
  bullet: boolean;
}

const DetailHeaderButton = ({
  view,
  activeView,
  setActiveView,
  bullet,
}: Props) => {
  const { value, label, icon, dataCy } = view;

  return (
    <div
      onClick={() => setActiveView(value)}
      className={clsx(
        classes.iconContainer,
        activeView === value && classes.active,
      )}
      data-cy={dataCy}
    >
      {bullet && <div className={classes.bullet}>•</div>}
      <div className={classes.icon}>
        <Icon color={colors.neutral.white} icon={icon} />
      </div>
      <div className={classes.label}>{label}</div>
    </div>
  );
};

export default DetailHeaderButton;
